import {decodeAbiParameters, parseAbiParameters} from "viem";

/**
 * Decode a Smelt Filing's completionData (the raw ABI-encoded LLM completion)
 * into the JSON content string the model produced. The contract cannot cheaply
 * parse the nested completion struct on-chain, so this happens off-chain.
 *
 * completionData layout (OpenAI-style):
 *   (string id, string object, uint256 created, string model,
 *    string systemFingerprint, string serviceTier, uint256 choicesCount,
 *    bytes[] choicesData, bytes usageData)
 * each choice: (uint256 index, string finishReason, bytes messageData)
 * messageData: (string role, string content, string refusal, uint256 toolCallsCount, bytes[])
 */
export function decodeFilingContent(rawCompletionOrSpc: `0x${string}` | undefined): string | null {
  if (!rawCompletionOrSpc || rawCompletionOrSpc === "0x") return null;
  try {
    const decoded = decodeAbiParameters(
      parseAbiParameters(
        "string, string, uint256, string, string, string, uint256, bytes[], bytes"
      ),
      rawCompletionOrSpc
    );
    const choicesCount = Number(decoded[6]);
    if (choicesCount === 0 || decoded[7].length === 0) return null;
    const choice = decodeAbiParameters(parseAbiParameters("uint256, string, bytes"), decoded[7][0]);
    const message = decodeAbiParameters(
      parseAbiParameters("string, string, string, uint256, bytes[]"),
      choice[2]
    );
    return message[1] as string;
  } catch {
    return null;
  }
}
